export default __webpack_public_path__ + "media/0118a0287071c8fe3acd8ba289b5efa08a6e9b56696954de7193b76f63fa6316.svg";